import * as s from "./HealthRing.style.css";
import type { HealthRingProps } from "./HealthRing.types";

export type { HealthRingProps, HealthRingSegment } from "./HealthRing.types";

export const HealthRing = ({
  segments,
  centerLabel,
  size = 72,
  strokeWidth = 8,
  "aria-label": ariaLabel,
}: HealthRingProps) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const total = segments.reduce((sum, seg) => sum + Math.max(seg.value, 0), 0);
  const center = size / 2;

  let offset = 0;
  return (
    <div className={s.ringWrap} role="img" aria-label={ariaLabel ?? centerLabel}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
        <circle cx={center} cy={center} r={radius} fill="none" className={s.track} strokeWidth={strokeWidth} />
        {total > 0 &&
          segments.map((seg) => {
            const len = (Math.max(seg.value, 0) / total) * circumference;
            if (len <= 0) return null;
            const dashoffset = -offset;
            offset += len;
            return (
              <circle
                key={seg.key}
                cx={center}
                cy={center}
                r={radius}
                fill="none"
                stroke={seg.color}
                strokeWidth={strokeWidth}
                strokeDasharray={`${len} ${circumference - len}`}
                strokeDashoffset={dashoffset}
                transform={`rotate(-90 ${center} ${center})`}
              />
            );
          })}
      </svg>
      <span className={s.centerLabel}>{centerLabel}</span>
    </div>
  );
};
